import type { ScopedRouteKey } from '@/app/routes';

export interface NavItem {
  kind: 'link' | 'section';
  label: string;
  routeKey?: ScopedRouteKey;
  icon?: string;
  accent?: boolean;
}

export const NAV: NavItem[] = [
  { kind: 'section', label: 'Үндсэн' },
  { kind: 'link', routeKey: 'dashboard', icon: 'bi-speedometer2', label: 'Хянах самбар' },
  { kind: 'link', routeKey: 'shipments', icon: 'bi-box-seam', label: 'Илгээмж' },
  { kind: 'link', routeKey: 'scan', icon: 'bi-upc-scan', label: 'Scan станц', accent: true },

  { kind: 'section', label: 'Тээвэр & хүргэлт' },
  { kind: 'link', routeKey: 'consolidations', icon: 'bi-boxes', label: 'Нэгтгэл' },
  { kind: 'link', routeKey: 'deliveries', icon: 'bi-truck', label: 'Хүргэлт' },

  { kind: 'section', label: 'Бүртгэл' },
  { kind: 'link', routeKey: 'customers', icon: 'bi-people', label: 'Харилцагч' },
  { kind: 'link', routeKey: 'warehouses', icon: 'bi-building', label: 'Агуулах' },
  { kind: 'link', routeKey: 'drivers', icon: 'bi-person-badge', label: 'Жолооч' },
  { kind: 'link', routeKey: 'tariffs', icon: 'bi-cash-coin', label: 'Тариф' },
];
